import { Component, Input, OnInit } from '@angular/core';
import { PaymentEquation } from '../../../payment/model/payment-equation';

@Component({
  selector: 'pioneer-payment-calculation',
  templateUrl: './payment-calculation.component.html'
})
export class PaymentCalculationComponent implements OnInit {

  @Input() currency: string;
  @Input() paymentEquation: PaymentEquation;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/components/payment-calculation/payment-calculation.component.ts